import React, { useState, useEffect } from 'react';

/**
 * Banner Beta global no intrusivo, descartable por sesion.
 */
const BetaBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const dismissed = sessionStorage.getItem('cualapp_beta_dismissed') === '1';
    setShow(!dismissed);
  }, []);

  if (!show) return null;
  return (
    <div data-testid="beta-banner" className="fixed top-0 inset-x-0 z-40 bg-amber-50 border-b border-amber-200 px-4 py-2 text-xs text-amber-900 flex items-center justify-center gap-3">
      <span className="font-semibold uppercase tracking-wide">Beta</span>
      <span className="hidden sm:inline">CUALAPP esta en beta. Funcionalidades pueden cambiar.</span>
      <a href="/terms-beta" data-testid="beta-banner-terms" className="underline hover:text-amber-700">Terminos</a>
      <span>·</span>
      <a href="/privacy" data-testid="beta-banner-privacy" className="underline hover:text-amber-700">Privacidad</a>
      <button
        data-testid="beta-banner-dismiss"
        onClick={() => { sessionStorage.setItem('cualapp_beta_dismissed', '1'); setShow(false); }}
        className="ml-2 text-amber-700 hover:text-amber-900"
        aria-label="Cerrar">
        ×
      </button>
    </div>
  );
};

export default BetaBanner;
